import { isEmpty, isEqual, isNil } from 'lodash'

export const NOT_APPLICABLE_CATEGORY = 'Not Applicable'

/**
 * The series a trend can actually plot.
 *
 * "Not Applicable" is the synthetic bucket for calls the insight ran against
 * but did not relate to, and it is excluded from the graph. A trend whose every
 * call landed there therefore has data and still has nothing to draw.
 *
 * @param {object} trend - a tracked insight with its results merged in
 */
export const plottableTrendSeries = (trend) =>
  (trend?.data ?? []).filter((series) => series.category !== NOT_APPLICABLE_CATEGORY)

// The synthetic "Not Applicable" series is excluded from the trend graph, so it
// is excluded from the export too — the export covers what the graph shows.
// Returns the deduped call id union plus, per call, the "; "-joined names of
// every series it appears in (the export's "Trend Series" column).
export const collectTrendCallData = (trend) => {
  const callIds = []
  const seriesByCallId = {}
  if (isEmpty(trend.data)) {
    return { callIds, callLabels: {} }
  }
  trend.data
    .filter((series) => series.category !== NOT_APPLICABLE_CATEGORY && !isEmpty(series.samples))
    .forEach((series) => {
      series.samples.forEach((sample) => {
        if (isNil(sample.call_id)) {
          return
        }
        if (!seriesByCallId[sample.call_id]) {
          seriesByCallId[sample.call_id] = []
          callIds.push(sample.call_id)
        }
        if (!seriesByCallId[sample.call_id].includes(series.category)) {
          seriesByCallId[sample.call_id].push(series.category)
        }
      })
    })
  const callLabels = {}
  callIds.forEach((callId) => {
    callLabels[callId] = seriesByCallId[callId].join('; ')
  })
  return { callIds, callLabels }
}

export const checkOrderDecklist = (insights, decklist) => {
  const orderSuggestion = []
  insights.forEach((insight) => {
    const matchingItem = Object.keys(decklist.entries).filter(
      (x) => decklist.entries[x].name === insight.item
    )
    if (matchingItem.length > 0) orderSuggestion.push(matchingItem[0])
  })
  const existingOrder = decklist.order.filter((item) => orderSuggestion.includes(item))
  return [isEqual(existingOrder, orderSuggestion), orderSuggestion]
}
